import { render } from "./OJ1012F.vue?vue&type=template&id=2ade65c6&scoped=true&ts=true"
import script from "./OJ1012F.vue?vue&type=script&lang=ts"
export * from "./OJ1012F.vue?vue&type=script&lang=ts"

import "./OJ1012F.vue?vue&type=style&index=0&id=2ade65c6&lang=css"

import exportComponent from "C:\\開発\\PSAP\\おくやみシステム\\OJ0000P_Vue\\OJ0000P\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ade65c6"]])

export default __exports__